const StateCams = {
    cams:{
        list:[],
        status:null,
        listStatus:[]
    }
}
const GettersCams = {
    getListCams:state=> state.cams.list,
    getListStatusCams:state=> state.cams.listStatus,
    getStatusCams:state=> state.cams.status,
    totalCamsConfigurada: state=>state.cams.list.length
}
const MutationCams = {
    setCams: (state, cams) => state.cams.list = cams,
    setListStatusCams: (state, cams) => state.cams.listStatus = cams,
    setStatusCams: (state, payload) => state.cams.status = payload,
    clearInformacoesCams: (state) => {
        state.status = null
        state.listStatus = []
        state.list = []
    } 
}
const ActionCams = {
    setCams: (context, payload) => context.commit('setCams', payload),
    setListStatusCams: (context, payload) =>{ 
        context.commit('setListStatusCams', payload)
        let status = false;
        if(payload.length>0) {
            payload.forEach(element => {
                if(element.status=='running') {
                    status = true
                }
            });
        }
            context.commit('setStatusCams', status)
    },
    setStatusCams: (context, payload) => context.commit('setStatusCams', payload),

}

export { StateCams, GettersCams, MutationCams, ActionCams } 